// tslint:disable: max-classes-per-file

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '@fry/lib/auth';
import { BaseMenuService, MenuItem } from '@fry/lib/menu';
import { SecurityService } from '@fry/lib/security';
import { RemoteUserService } from '@fry/lib/users';

const baseTypesMenu = [
  {
    id: 'booking-types',
    link: '/booking-types',
    title: $localize `Booking types`,
    parent: 'manage-booking'
  }
];

const baseItemsMenu = [
  {
    id: 'booking-items',
    link: '/booking-items',
    title: $localize `Booking items`,
    parent: 'manage-booking'
  }
];

const baseVenuesMenu = [
  {
    id: 'venues',
    link: '/venues',
    title: $localize `Venues`,
    parent: 'manage-booking'
  }
];

const baseBulkActionsMenu = [
  {
    id: 'bulk-actions',
    link: '/bulk-actions',
    title: $localize `Bulk Actions`,
    parent: 'manage-booking'
  }
];

const baseUserBookingsMenu = [
  {
    id: 'available',
    link: '/bookings/available',
    title: $localize `Available bookings`,
    parent: 'bookings'
  },
  {
    id: 'my-bookings',
    link: '/bookings',
    title: $localize `My bookings`,
    parent: 'bookings'
  }
];


const baseBookingsMenu = [
 {
    id: 'all-bookings',
    link: '/all-bookings',
    title: $localize `All bookings`,
    parent: 'bookings'
  }
];

const remoteMenu: MenuItem[] = [
  {
    id: 'all-bookings',
    link: '/users/:user/all-bookings',
    title: $localize `Bookings`,
  },
  {
    id: 'available',
    link: '/users/:user/available',
    title: $localize `Available bookings`,
  },
];

@Injectable()
export class BookingMenu extends BaseMenuService {

    constructor(auth: AuthService, security: SecurityService) {
        super(auth, security);
    }

    cook(): Observable<MenuItem[]> {
        return this.mergeItems(
            of([{
              id: 'manage-booking',
              title: $localize `Manage Booking`
            }]),
            of([{
              id: 'bookings',
              title: $localize `Bookings`
            }]),
            this.menuWithPermission(baseTypesMenu, 'bookingTypes.view'),
            this.menuWithPermission(baseItemsMenu, 'bookingItems.view'),
            this.menuWithPermission(baseVenuesMenu, 'venues.view'),
            this.menuWithPermission(baseBulkActionsMenu, 'bookings.manage'),
            this.menuWithPermission(baseUserBookingsMenu, 'bookings.view.own'),
            this.menuWithPermission(baseBookingsMenu, 'bookings.view'),
        );
    }
}

@Injectable()
export class BookingRemoteMenu extends BaseMenuService {
    constructor(protected auth: AuthService,
                protected security: SecurityService,
                private remoteUser: RemoteUserService) {
        super(auth, security);

        this.startUpdating();
    }

    cook(): Observable<MenuItem[]> {
        return this.mergeItems(
            this.menuWithPermission(remoteMenu, 'bookings.view')
        ).pipe(
          map(items => {
            if (!this.remoteUser.user) { return []; }
            return items.map(item => {
              return {
                ...item,
                link: item.link.replace(/:user/, this.remoteUser.user.doc.user),
              };
            });
          })
        );
    }

    public startUpdating() {
        if (!this.remoteUser) { return; }
        this.remoteUser.user$.subscribe((user) => {
          if (user) {
            this.updateMenu();
          }
        });
    }
}
